export default [
    function () {
        return {
            restrict: 'EA',
            scope: {
                message: '=eeeMessage',
            },
            template: `
                <span title="{{ message.date | unixToTimestring:true }}">{{ message.date | unixToTimestring }}</span>
            `,
        };
    },
];
